import {
  mdiCalendarArrowRight,
  mdiClipboardCheckOutline,
  mdiOpenInNew,
  mdiRefresh,
  mdiClose,
  mdiEye,
  mdiPaperclip,
  mdiCashMultiple,
  mdiFileMultiple,
  mdiCloudSync,
  mdiHistory,
  mdiExportVariant,
  mdiContentCopy,
  mdiCheck,
  mdiAccountPlus,
  mdiAccountCancel,
  mdiDotsVertical,
  mdiEmailCheck,
  mdiKey,
  mdiLockOpen,
  mdiPencil,
  mdiRestore,
  mdiShieldAccount,
  mdiTrashCanOutline,
  mdiAccount,
  mdiCalendarText,
  mdiCellphoneArrowDown,
  mdiChevronDown,
  mdiCog,
  mdiInformationOutline,
  mdiLink,
  mdiLock,
  mdiLogout,
  mdiShareVariant,
  mdiThemeLightDark,
  mdiWeatherNight,
  mdiWhiteBalanceSunny,
} from "@mdi/js";

// Match the Expo app's constants/IconVocabulary.ts concepts and glyphs.
export const SEMANTIC_ICONS = {
  close: mdiClose,
  profile: mdiAccount,
  moveEvent: mdiCalendarArrowRight,
  admin: mdiShieldAccount,
  createUser: mdiAccountPlus,
  actions: mdiDotsVertical,
  edit: mdiPencil,
  password: mdiKey,
  verifyEmail: mdiEmailCheck,
  unlock: mdiLockOpen,
  ban: mdiAccountCancel,
  refresh: mdiRefresh,
  revert: mdiRestore,
  restore: mdiRestore,
  delete: mdiTrashCanOutline,
  copy: mdiContentCopy,
  confirmed: mdiCheck,
  view: mdiEye,
  attachments: mdiPaperclip,
  costs: mdiCashMultiple,
  duplicateTrip: mdiFileMultiple,
  cloudSync: mdiCloudSync,
  importActivityHistory: mdiHistory,
  exportData: mdiExportVariant,
  mobileApps: mdiCellphoneArrowDown,
  settings: mdiCog,
  connection: mdiLink,
  signOut: mdiLogout,
  leaveTrip: mdiLogout,
  chevronDown: mdiChevronDown,
  events: mdiCalendarText,
  eventCheckIn: mdiClipboardCheckOutline,
  externalLink: mdiOpenInNew,
  tripMembers: mdiAccount,
  lock: mdiLock,
  share: mdiShareVariant,
  information: mdiInformationOutline,
  themeSystem: mdiThemeLightDark,
  themeLight: mdiWhiteBalanceSunny,
  themeDark: mdiWeatherNight,
} as const;

// @mdi/react forwards additional SVG props, as documented in its README.
export const decorativeIconProps = {
  "aria-hidden": true,
  focusable: "false",
} as const;
